import { db } from '@/shared/db/database';

export interface AuthSession {
  token: string;
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  idPerson: number;
  idEntity: number;
  idClient: number;
  idInstance: number;
  accessRoles: number[];
  isAdminDevice: boolean;
  timezone: string;
  forceChangePassword: boolean;
}

const TOKEN_KEY = 'mi_authToken';
const AUTH_KEY = 'mi_authed';
const SESSION_KEY = 'mi_session';

export function saveAuthSession(session: AuthSession): void {
  localStorage.setItem(TOKEN_KEY, session.token);
  localStorage.setItem(AUTH_KEY, '1');
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  
  // NOTE: We do NOT save session.timezone to Dexie here because:
  // 1. session.timezone = user preference (from user.settings_user.timezone_pg)
  // 2. Device enrollment needs ACTUAL browser location (Intl.DateTimeFormat)
  // 3. useEnrollDeviceOnLogin handles saving browser timezone after enrollment
  // 
  // Previously this created a race condition where backend timezone would
  // overwrite browser timezone, causing devices to enroll with wrong location.
}

export function loadAuthSession(): AuthSession | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as AuthSession;
  } catch {
    return null;
  }
}

export function clearAuthSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem('mi_profile_chosen');
  localStorage.removeItem('mi_admin_session');
  
  // Clear cached access roles from IndexedDB to prevent showing previous user's
  // profiles when a new user logs in. Without this, React Query would serve stale
  // profiles from the cache until the backend fetch completes.
  db.accessRoles.clear().catch((err) => {
    console.warn('[clearAuthSession] Failed to clear accessRoles cache:', err);
  });
}

export function isSessionValid(): boolean {
  return localStorage.getItem(AUTH_KEY) === '1' && !!localStorage.getItem(TOKEN_KEY);
}
